<template>
	<component
		:is="componentFile"
		:color="color"
		:fill="fill"
		:stroke="stroke"
		:width="width"
		:height="height"
		:view-box="`0 0 ${width} ${height}`"
	/>
</template>

<script>
export default {
	name: 'SVGIcon',
	props: {
		iconName: {
			type: String,
			required: true
		},

		width: {
			type: [Number, String],
			default: 35
		},

		height: {
			type: [Number, String],
			default: 35
		},

		fill: {
			type: String,
			default: 'currentColor'
		},

		color: {
			type: String,
			default: ''
		},

		stroke: {
			type: String,
			default: 'none'
		}
	},
	computed: {
		componentFile() {
			return this.importComponent(this.iconName)
		},
		bindings () {
			const { fill, stroke, width, height } = this

			return { fill, stroke, width, height }
		}
	},
	methods: {
		importComponent(path) {
			return () => import(`~/assets/icons/${path}.svg?inline`)
		}
	}
}
</script>
